import { Payment } from "@omni/types/api/cart/bff/shared/payment.model";
import { isEmpty } from "lodash-es";

import { PaymentMethodComponent } from "./paymentMethod.component";

type PaymentMethodsProps = {
    payments: Array<Payment>;
    showAmount: boolean;
};

const PaymentMethods = ({ payments, showAmount }: PaymentMethodsProps) => {
    if (isEmpty(payments)) return null;

    return (
        <ul className={"list-unstyled"}>
            {payments.map((payment) => (
                <PaymentMethodComponent
                    key={payment.paymentMethodCode + payment.issuer}
                    payment={payment}
                    showAmount={showAmount}
                />
            ))}
        </ul>
    );
};

export { PaymentMethods };
